import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ChangePassword from "components/ChangePassword";
import { changePassword } from "actions/changePasswordActions";

export const mapStateToProps = state => {
  return {
    open: state.loader.open,
    calls: state.loader.calls
  };
};

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      changePassword: changePassword,
    },
    dispatch
  );
};

const ChangePasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);

export default ChangePasswordContainer;
